<template>
  <!-- level 1 -->
  <article
    v-if="$store.getters.getCurrentLevel === 1 && isLoaded"
    class="product-card"
  >
    <router-link
      :to="cLink(`/fertige/${item.id}`)"
      class="product-card__photo-wrapper"
      :class="{ '--has-no-frame': (item && item.photos && item.photos[$store.getters.groupAbb].length > 0) ? false : true }"
    >
      <ImgLazy
        v-if="item && item.photos && item.photos[$store.getters.groupAbb].length > 0"
        :srcset="`
          ${item.photos[$store.getters.groupAbb][0].original}?format=${webPFormat('jpeg')}&width=800&quality=80 2x,
          ${item.photos[$store.getters.groupAbb][0].original}?format=${webPFormat('jpeg')}&width=400&quality=80 1x
        `"
        :src="`${item.photos[$store.getters.groupAbb][0].original}?format=${webPFormat('jpeg')}&width=400&quality=80`"
        :alt="item.name"
        class="product-card__photo"
      />

      <PresentPhotoVirtual
        v-else
        :products="item.products"
      />

      <div class="product-card__badges">
        <div v-if="$store.getters.isAdminMode" class="product-card__badge">Qty: <b>{{ level1MaxQty(item) }}</b></div>
      </div>
    </router-link>

    <div class="product-card__info" v-if="item">
      <h4 class="product-card__title notranslate"><router-link :to="cLink(`/fertige/${item.id}`)">{{ item.name }}</router-link></h4>
      <span class="product-card__tags">
        <ul class="product-card__ul">
          <li v-for="tag in item.level1_tags" :key="tag.level1_feature_title">
            <Popper placement="top">
            <span class="u-text-muted product-card__feature"><a :style="{'color':tag.level1_feature_color}"><i class="product-card__icon" v-html="addClassToIcon(tag.level1_feature_icon, tag.level1_feature_color)"></i>  {{ tag.level1_feature_title }}</a></span>
                <template v-slot:popover>
                  <slot>
                    {{ tag.level1_feature_description }}
                  </slot>
                  </template>
                </Popper>
          </li>
        </ul>
      </span>
      <span class="product-card__short_description">
        {{ cleanDescString(item.description) }}
      </span>
        <div class="summary__slot">
          <slot v-if="$store.getters.isB2b && boxQty<=1">
            <AvailabilityOverview :item="item"/>
          </slot>
          <slot v-else>
            <Availability v-if="item" class="product-card__availability" :stock="true" :stockNr="boxQty" :time="getCalculatedTime(item)" />
            <Popper placement="top">
              <span class="u-text-muted"><a>Später gewünscht?</a></span>
                <template v-slot:popover>
                  <slot v-if="boxQty === 1">
                    <b>Sie wünschen eine verzögerte Lieferung?</b><br>Gerne können wir den Versand zu einem späteren Zeitpunkt durchführen. Wählen Sie bei den Liefereinstellungen die Option "Lieferung verzögern" und geben Sie Ihren gewünschten Versandtermin an.
                  </slot>
                  <slot v-else>
                    <b>Sie wünschen eine verzögerte Lieferung?</b><br>Gerne können wir den Versand zu einem späteren Zeitpunkt durchführen. Geben Sie Ihren gewünschten Versandtermin bitte im Feld "Anmerkungen zu Ihrer Bestellung" beim Bezahlvorgang an (unter "Rechnungsdetails").
                  </slot>
                </template>
            </Popper>
          </slot>
        </div>
    </div>

    <div class="product-card__footer">
      <Price align="left">
          <template v-slot:brutto>{{ humanPrice(getPriceRawForGroup(item, $store.getters.getUserGroupId, false) + getBoxPriceLvl1(item, $store.getters.getUserGroupId, false)) }}</template>
          <template v-slot:netto>{{ humanPrice(getPriceRawForGroup(item, $store.getters.getUserGroupId, true) + getBoxPriceLvl1(item, $store.getters.getUserGroupId, true)) }}</template>
      </Price>

      <Button
        type="router"
        :to="`/fertige/${item.id}`"
        appearance="secondary"
        size="small"
      >Anzeigen</Button>
    </div>
  </article>
  <!-- /level 1 -->

  <!-- level 3 -->
  <article
    v-else-if="$store.getters.getCurrentLevel === 3 && isLoaded"
    class="product-card"
    :class="{ '--is-selected': $store.getters.getSelectedItem.data !== null && $store.getters.getSelectedItem.data.id === item.id }"
  >
    <router-link
      :to="cLink(`/zusammenstellen/${item.id}/details`)"
      class="product-card__photo-wrapper"
    >
      <ImgLazy
        v-if="item.photos[$store.getters.groupAbb] && item.photos[$store.getters.groupAbb][0] && item.photos[$store.getters.groupAbb][0].original"
        :srcset="`
          ${item.photos[$store.getters.groupAbb][0].original}?format=${webPFormat('jpeg')}&width=400&quality=70 2x,
          ${item.photos[$store.getters.groupAbb][0].original}?format=${webPFormat('jpeg')}&width=200&quality=70 1x
        `"
        :src="`${item.photos[$store.getters.groupAbb][0].original}?format=${webPFormat('jpeg')}&width=200&quality=70`"
        :alt="item.name"
        class="product-card__photo"
      />

      <div class="product-card__badges">
        <img
          v-if="item.origin_iso && getFlagPath(item.origin_iso.toLowerCase()) !== ''"
          :src="getFlagPath(item.origin_iso.toLowerCase())"
          class="product-card__flag"
        >

        <div v-if="$store.getters.isAdminMode" class="product-card__badge">Qty: <b>{{ item.stock_quantity }}</b></div>
      </div>

      <div
        v-if="$store.getters.getLevel3Helper[item.id] && !$store.getters.getLevel3Helper[item.id].placeable"
        class="product-card__photo-overlay"
      >
        <i class="icon icon-ban"></i>
        Leider ist nicht mehr genug Platz für diese Köstlichkeit.
      </div>
    </router-link>

    <div class="product-card__info">
      <h4 class="product-card__title notranslate"><router-link :to="cLink(`/zusammenstellen/${item.id}/details`)">{{ item.name }}</router-link></h4>

      <slot v-if="$store.getters.isAdminMode">
        <pre v-if="$store.getters.getAdminData.Gerichshain[item.sku]">{{ JSON.stringify($store.getters.getAdminData.Gerichshain[item.sku], undefined, 1).replace('{', 'Gerichshain:').replace('}', '').replaceAll('"', '').replaceAll(',', '') }}</pre>
        <button @click="getOrderData">Verkauf laden</button> {{ orderData }}
      </slot>

      <p class="product-card__description"><span v-html="productDetailStringVar1Bold1(item)"></span>, von {{ item.manufacturer }}</p>

      <Availability v-if="item" class="product-card__availability" :stock="true" :stockNr="boxQty" :time="getCalculatedTime(item)" />
    </div>

    <div class="product-card__footer">
      <Price align="left">
        <template v-slot:brutto>{{ getPriceLevel3ForGroup(item, $store.getters.getUserGroupId, false) }}</template>
        <template v-slot:netto>{{ getPriceLevel3ForGroup(item, $store.getters.getUserGroupId, true) }}</template>
      </Price>

      <Button
        @click="selectItem(item)"
        appearance="secondary"
        size="small"
        :disabled="$store.getters.getLevel3Helper[item.id] && !$store.getters.getLevel3Helper[item.id].placeable"
      >+</Button>
    </div>
  </article>
  <!-- /level 3 -->

  <!-- placeholder -->
  <article
    v-else
    class="product-card --is-placeholder"
  >
    <div class="product-card__photo-wrapper">
      <span class="product-card__photo"></span>
    </div>

    <h3 class="product-card__title"><span></span></h3>

    <div class="product-card__footer">
      <div class="product-card__price">
        <b></b>
        <span></span>
      </div>
    </div>
  </article>
  <!-- /placeholder -->
</template>

<script>
import Availability from '@/components/Common/Availability';
import Button from '@/components/Common/Button';
import ImgLazy from '@/components/Common/ImgLazy';
import PresentPhotoVirtual from '@/components/Common/PresentPhotoVirtual';
import Price from '@/components/Common/Price';
import Popper from '@/components/Popper';
import AvailabilityOverview from '@/components/PresentPage/AvailabilityOverview';
import { calculateDeliveryTimeForProduct } from '@/helper/functions';
import { helperMixin } from '@/mixins/HelperMixin';
import { logicMixin } from '@/mixins/LogicMixin';

export default {
  name: 'ProductCard',
  mixins: [logicMixin, helperMixin],
  props: {
    isLoaded: {
      type: Boolean,
      default: true
    },
    item: {
      type: Object
    }
  },
  components: {
    ImgLazy,
    PresentPhotoVirtual,
    Availability,
    AvailabilityOverview,
    Price,
    Button,
    Popper
  },
  data() {
    return {
      orderData: ''
    };
  },
  methods: {
    getFlagPath: function(iso) {
      try {
        return require(`@/assets/images/landing-page/flags/${iso}.svg`);
      } catch (ex) {
        return '';
      }
    },

    selectItem: function (item) {
      if (item.type === 'level_1' && parseInt(this.$route.params.id) !== item.id) {
        this.$router.push(this.cLink('/fertige/' + item.id));

        this.$root.$emit('selectedOrAddedItem');

        if (document.getElementsByClassName('--hide-on-scroll').length > 0) {
          document.getElementsByClassName('--hide-on-scroll')[0].scrollTop = 0;
        }
      } else {
        this.addLevel3(item);

        // Add animation only if desktop
        if (this.$store.getters.getMediaQueries.min.md.matches) {
          const photoClone = document.createElement('img');

          photoClone.setAttribute('src', `${item.photos[this.$store.getters.groupAbb][0].original}?format=${this.webPFormat('jpeg')}&width=200&quality=70`);
          photoClone.setAttribute('srcset', `${item.photos[this.$store.getters.groupAbb][0].original}?format=${this.webPFormat('jpeg')}&width=400&quality=70 2x, ${item.photos[this.$store.getters.groupAbb][0].original}?format=${this.webPFormat('jpeg')}&width=200&quality=70 1x`);
          photoClone.setAttribute('class', 'product-card__photo-clone');

          this.$el.appendChild(photoClone);

          setTimeout(() => {
            photoClone.remove();
          }, 600);
        }
      }
    },
    getCalculatedTime(item) {
      // this.doReplace();
      this.$store.getters.getListItemsLevel1Unfiltered.forEach(lvl1 => {
        if (lvl1.id === this.item.id) {
          item = lvl1;
        }
      });
      var addForChristmas = 0;
      if ([62, 2569, 2571, 2548].includes(parseInt(this.$store.getters.getUserGroupId))) {
        addForChristmas = 0;
      }
      var time = 0;
      if (this.$store.getters.getCurrentLevel === 1) {
        if (typeof (item.products) !== 'undefined') {
          item.products.forEach((product) => {
            if (product.replaced) {
              product = product.replaceData;
            }
            const tempTime = calculateDeliveryTimeForProduct(
              product,
              this.$store.getters.getSelectedQty,
              this.$store.getters.getDelTimeSettings
            );
            if (tempTime > time) {
              time = tempTime;
            }
          });
        }
      } else if (this.$store.getters.getCurrentLevel === 3) {
        time = calculateDeliveryTimeForProduct(
          item,
          this.$store.getters.getSelectedQty,
          this.$store.getters.getDelTimeSettings
        );
      }

      return time + addForChristmas;
    },

    getOrderData() {
      fetch(process.env.VUE_APP_API_URL + '/apiStatistics/' + this.item.sku).then(res => res.json()).then(data => { this.orderData = data; });
    },

    cleanDescString(descWithTags) {
      return descWithTags.replace(/(<([^>]+)>)/ig, '');
    },

    addClassToIcon(icon, color) {
      return icon.replace('<svg', '<svg class="product-card__icon"').replace(/height="[0-9]{2,}"/ig, '').replace(/width="[0-9]{2,}"/ig, '').replace('></path>', 'style=fill:' + color + '></path>');
    }
  }
};
</script>

<style lang="scss" scoped>
/**
 * ProductCard
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Product Card for the Configurator
 * @since 2021-09-28
**/

$component: 'product-card';

h6{
  font-weight: 400;
}

.#{$component} {
  position: relative;

  @include hover () {
    outline: 10px solid $sky-lighter;
    background-color: $sky-lighter;

    .#{$component}__photo-wrapper {
      background-color: $white;
    }
  }

  &__photo-wrapper {
    display: block;
    position: relative;
    @include margin-bottom(map-get($spacers, 2));
    @include padding(map-get($spacers, 4));
    border: 1px solid $gray-ghost;
    border-radius: $border-radius;
    // background-color: $white;
    cursor: pointer;

    &.--has-no-frame {
      padding: 0;
      border: none;
    }
  }

  &__photo {
    border-radius: $border-radius-sm;
  }

  &__feature {
    font-size: 0.8rem;
  }

  &__ul {
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    padding-left: 0rem;
  }

  &__ul li {
    width: calc(50%);
    margin: 0px;
    padding: 0px;
    box-sizing: border-box;
    text-align: left;
  }

  &__ul li:nth-child(even) {
    text-align: left;
  }

  &__ul li:not(:last-child)::after {
  content: " ";
  }

  &__icon {
    height: 1rem;
    width: 1rem;
    display: inline-block;
  }

  // For level 3 "add" animation
  @keyframes photo-clone {
    0% {
      opacity: 0.6;
    }

    100% {
      width: 40px;
      height: 40px;
      transform: translate3d(50px, -30px, 0);
      opacity: 0;
    }
  }

  ::v-deep &__photo-clone {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 30px;
    height: 30px;
    animation: photo-clone 0.4s forwards;
  }

  &__photo-overlay {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    @include padding(map-get($spacers, 3));
    background: rgba($white, 0.9);
    color: $ink-lighter;
    text-align: center;

    .icon {
      @include margin-bottom(map-get($spacers, 2));
      @include font-size($font-size-base * 1.8);
    }

  }

  &__badges {
    position: absolute;
    display: flex;
    @include rfs(0.6rem, top);
    @include rfs(0.6rem, left);
  }

  &__badge {
    display: flex;
    align-items: center;
    height: 20px;
    @include padding(0 map-get($spacers, 2));
    border-radius: 50px;
    background-color: $yellow;
    @include font-size($font-size-sm / 1.2);

    &:not(:last-child) {
      @include margin-right(map-get($spacers, 1));
    }
  }

  &__flag {
    width: 20px;
    height: 20px;
    @include margin-right(map-get($spacers, 2));
    border-radius: 50%;
  }

  &__info {
    @include margin-bottom(map-get($spacers, 3));
  }

  &__title {
    display: -webkit-box;
    /* @include rfs($line-height-base * 1.4 + 'rem', height);+ */
    @include margin(0 0 map-get($spacers, 1) 0);
    @include font-size($font-size-base * 1.04);
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    cursor: pointer;

    a {
      color: $ink;
    }
  }

  &__short_description {
    @include rfs($line-height-base-sm * 3 + 'rem', height);
    overflow: hidden;
    font-size: 0.8rem;
    line-height: $line-height-base-sm;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    display: inline-flex;
  }

  &__description {
    display: -webkit-box;
    @include rfs($line-height-base-sm * 1.6 + 'rem', height);
    overflow: hidden;
    color: $ink-lighter;
    @include font-size($font-size-sm);
    line-height: $line-height-base-sm;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  &__availability {
    @include font-size($font-size-sm);
    line-height: $line-height-base-sm;
  }

  &__footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  // States
  &.--is-selected .#{$component} {
    &__photo-wrapper {
      border: 2px solid $primary;
      box-shadow: 0px 0px 10px rgba($primary, 0.3);

      &:after {
        content: '\e912';
        position: absolute;
        @include rfs(- $font-size-base / 1.6, bottom);
        right: 50%;
        left: 50%;
        width: $font-size-base * 1.6;
        height: $font-size-base * 1.6;
        border: 2px solid $white;
        border-radius: 50%;
        background-color: $white;
        color: $primary;
        font-family: 'icomoon';
        font-size: $font-size-base * 1.4;
      }
    }

    &__photo {
      width: calc(100% + 2px);
      max-width: unset;
      margin: -1px;
    }
  }

  /* Placeholder */
  &.--is-placeholder {
    animation: fading 1.5s infinite;

    .#{$component} {
      * {
        cursor: default !important;
      }

      &__photo-wrapper {
        background-color: $sky;
        cursor: default;
      }

      &__photo {
        display: block;
        width: 100%;
        height: auto;
        object-fit: fill;
        aspect-ratio: 1 / 1;
      }

      &__title {
        cursor: default;

        span {
          display: block;
          width: 70%;
          height: $font-size-base;
          background: $ink-lightest;
        }
      }

      &__price {
        b {
          display: block;
          @include rfs(5rem, width);
          height: $font-size-base;
          background: $ink-lightest;
        }

        span {
          display: block;
          @include rfs(3rem, width);
          height: $font-size-sm;
          @include margin-top(map-get($spacers, 1));
          background: $sky-dark;
        }
      }
    }

    @keyframes fading {
      0% {
      opacity: 1;
      }

      50% {
        opacity: 0.6;
      }

      100% {
        opacity: 1;
      }
    }
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
    &__title {
      height: auto;
    }
  }
}
</style>
